export const Navigation = {
  methods: {
    navigateTo(to) {
      if (this.$route.path === to) return;
      return this.$router.push(to);
    },
  },
};
